<template>
  <Content
    class="col-span-full"
    :title="$route.name"
    :showAdd="false"
    :pagination="{
      count: tableData.count,
      current: +$route.query.p,
      request: 'rules/events/',
    }"
    @tableData="tableData = $event"
    @loading="loading = $event"
  >
    <tableSearch
      :searchable="false"
      :loading="searchLoading"
      @search="searchEvents"
      :searchValue="searchValue"
    >
      <VehicleSelect
        :label="$t('VEHICLE_TITLE')"
        prop="company_vehicle"
        :model="companyVehicle"
        @update="vehicleChanged"
      />
      <el-form-item :label="$t('START_DATE')" prop="dateRange.start_from">
        <date-picker
          v-model="dateRange.start_from"
          type="date"
          :locale="$i18n.locale"
          format="jYYYY-jMM-jDD"
          @change="handleDateChange"
          color="#151515"
          class="el-input__inner"
          clearable
        />
      </el-form-item>
      <el-form-item :label="$t('END_DATE')" prop="dateRange.start_to">
        <date-picker
          v-model="dateRange.start_to"
          type="date"
          :locale="$i18n.locale"
          format="jYYYY-jMM-jDD"
          @change="handleDateChange"
          color="#151515"
          class="el-input__inner"
          clearable
        />
      </el-form-item>
    </tableSearch>

    <el-table
      :empty-text="$t('NO_DATA')"
      :data="tableData.results"
      v-loading="loading"
      :stripe="true"
      style="width: 100%"
    >
      <el-table-column
        sortable
        type="index"
        :align="$i18n.locale == 'fa' ? 'right' : 'left'"
        :label="$t('INDEX')"
        width="60"
      >
        <template slot-scope="scope">
          <div :data-title="$t('INDEX')">
            {{ scope.$index + 1 }}
          </div>
        </template>
      </el-table-column>

      <el-table-column
        :align="$i18n.locale == 'fa' ? 'right' : 'left'"
        :label="$t('VEHICLE_TITLE')"
        width="100"
      >
        <template slot-scope="scope">
          <LicensePlate
            v-if="scope.row.company_vehicle"
            :vehicle="scope.row.company_vehicle.vehicle"
            :license_plate="scope.row.company_vehicle.license_plate"
            :chars="alphaList"
          />
        </template>
      </el-table-column>

      <el-table-column
        :align="$i18n.locale == 'fa' ? 'right' : 'left'"
        :label="$t('TITLE')"
        width="120"
      >
        <template slot-scope="scope">
          <div :data-title="$t('TITLE')">
            {{ scope.row.rule && scope.row.rule.title }}
          </div>
        </template>
      </el-table-column>

      <el-table-column
        :align="$i18n.locale == 'fa' ? 'right' : 'left'"
        :label="$t('METRICS')"
        width="150"
      >
        <template slot-scope="scope">
          <div :data-title="$t('METRICS')">
            <div
              v-for="condition in (scope.row.rule &&
                scope.row.rule.rule_conditions) ||
              []"
              :key="condition.id"
              class="mb-1"
            >
              <span class="text-sm font-medium">
                {{
                  $i18n.locale == 'fa'
                    ? condition.metric.fa_title
                    : condition.metric.en_title
                }}
              </span>
              <el-button
                v-if="hasFence(scope.row) && condition.metric.code === 'fence'"
                type="text"
                class="text-carpo"
                @click="openFence(scope.row)"
              >
                {{ $t('VIEW') }}
              </el-button>
              <span
                class="text-xs text-gray-500 ml-1"
                v-if="condition.metric.unit"
              >
                ({{ condition.metric.unit }})
              </span>
            </div>
          </div>
        </template>
      </el-table-column>

      <el-table-column
        :align="$i18n.locale == 'fa' ? 'right' : 'left'"
        :label="$t('CONDITION_RULES')"
        width="200"
      >
        <template slot-scope="scope">
          <div :data-title="$t('CONDITION_RULES')">
            <div
              v-for="condition in (scope.row.rule &&
                scope.row.rule.rule_conditions) ||
              []"
              :key="condition.id"
              class="mb-1 text-sm gap-1 flex items-center"
            >
              <span class="font-mono text-xs bg-gray-100 rounded">
                {{
                  $i18n.locale == 'fa'
                    ? condition.operator.fa_title
                    : condition.operator.en_title
                }}
              </span>

              <span class="text-xs text-gray-500" v-if="condition.metric.unit">
                {{ condition.metric.unit }}
              </span>
              <span v-if="condition.metric.code !== 'fence'">
                {{ condition.threshold.value }}
              </span>
            </div>
          </div>
        </template>
      </el-table-column>

      <el-table-column
        :align="$i18n.locale == 'fa' ? 'right' : 'left'"
        :label="$t('TIME')"
        width="150"
      >
        <template slot-scope="scope">
          <div :data-title="$t('TIME')" class="flex flex-col">
            <span>
              {{ new Date(scope.row.start_time).toLocaleTimeString('fa-IR') }} |
              {{ new Date(scope.row.start_time).toLocaleDateString('fa-IR') }}
            </span>
            <span v-if="scope.row.end_time">
              {{ new Date(scope.row.end_time).toLocaleTimeString('fa-IR') }} |
              {{ new Date(scope.row.end_time).toLocaleDateString('fa-IR') }}
            </span>
          </div>
        </template>
      </el-table-column>

      <el-table-column label="" width="50">
        <template slot-scope="scope">
          <div class="fixed-column">
            <tableFeatures
              :description="scope.row.description"
              :router="{
                name: 'REPORT_RULES_DETAIL',
                id: scope.row.id,
              }"
              :view="true"
              :Editable="false"
              :isDeleteable="false"
              :title="$t('REPORT_RULES_DETAIL')"
              @view="view(scope.row.id)"
            />
          </div>
        </template>
      </el-table-column>
    </el-table>

    <el-dialog :visible.sync="showMap" :title="$t('GEOFENCE')" width="60%">
      <div ref="mapElement" style="height: 60vh; width: 100%"></div>
    </el-dialog>
  </Content>
</template>

<script>
import { RulesEvents } from '@/api/reports'
import { licenseChars } from '@/api/global'
import LicensePlate from '@/components/cars/LicensePlate'
import config from '@/configs/configs'
import tableSearch from '@/components/elements/tableSearch'
import VehicleSelect from '@/components/elements/vehiclesSelect.vue'
import { jalaliToGregorian } from '@/mixins/jalaliToGregorian'
import tableFeatures from '@/components/elements/tableFeatures'

export default {
  mixins: [jalaliToGregorian],
  components: { LicensePlate, tableSearch, VehicleSelect, tableFeatures },
  data() {
    return {
      loading: true,
      searchLoading: false,
      searchValue: '',
      tableData: { results: [] },
      alphaList: [
        {
          code: '',
          char: '',
          id: '',
        },
      ],
      dateRange: {
        start_from: null,
        start_to: null,
      },
      companyVehicle: null,
      showMap: false,
      currentFenceCoords: null,
      map: null,
      polygonLayer: null,
    }
  },
  mounted() {
    this.loadInitialData()
    licenseChars.api().then((res) => {
      this.alphaList = res
    })
  },
  methods: {
    view(id) {
      this.$router.push({ name: 'REPORT_RULES_DETAIL', params: { id } })
    },
    searchEvents(val) {
      this.searchValue = val
      this.fetchData()
    },
    handleDateChange() {
      this.fetchData()
    },
    vehicleChanged(id) {
      this.companyVehicle = id
      this.fetchData()
    },
    loadInitialData() {
      const { start_from, start_to, company_vehicle, search } =
        this.$route.query
      this.dateRange.start_from = start_from || null
      this.dateRange.start_to = start_to || null
      this.companyVehicle = company_vehicle ? +company_vehicle : null
      this.searchValue = search || ''
      this.fetchData()
    },
    fetchData() {
      this.searchLoading = true
      this.loading = true

      const params = {}
      if (this.dateRange.start_from) {
        params.start_from = this.jalaliToGregorian(
          this.dateRange.start_from,
          this.$i18n.locale
        )
      }
      if (this.dateRange.start_to) {
        params.start_to = this.jalaliToGregorian(
          this.dateRange.start_to,
          this.$i18n.locale
        )
      }
      if (this.companyVehicle) {
        params.company_vehicle = this.companyVehicle
      }
      if (this.searchValue) {
        params.search = this.searchValue || undefined
      }

      this.$router.replace({
        query: {
          ...this.$route.query,
          start_from: this.dateRange.start_from || undefined,
          start_to: this.dateRange.start_to || undefined,
          search: this.searchValue || undefined,
          company_vehicle: this.companyVehicle || undefined,
        },
      })

      RulesEvents.api(params).then((res) => {
        if (res) this.tableData = res
        this.loading = false
        this.searchLoading = false
      })
    },
    hasFence(row) {
      if (!row.rule || !row.rule.rule_conditions) return false
      return row.rule.rule_conditions.some(
        (c) => c.metric && c.metric.code === 'fence'
      )
    },
    openFence(row) {
      const cond = ((row.rule && row.rule.rule_conditions) || []).find(
        (c) => c.metric && c.metric.code === 'fence'
      )
      if (!cond || !cond.threshold || !cond.threshold.value) return
      const value = cond.threshold.value

      // Normalize coordinates to [[lng,lat], ...]
      let coords = []
      if (
        Array.isArray(value.coordinates) &&
        Array.isArray(value.coordinates[0])
      ) {
        // If first element is a number pair, wrap; if it is a ring, take first ring
        if (typeof value.coordinates[0][0] === 'number') {
          coords = value.coordinates
        } else {
          coords = value.coordinates[0]
        }
      }

      this.currentFenceCoords = coords.map((c) => [c[1], c[0]])
      this.showMap = true
      this.$nextTick(() => this.loadMap())
    },
    loadMap() {
      if (!this.$refs.mapElement) return
      if (!this.map) {
        const map = L.map(this.$refs.mapElement, { tap: false }).setView(
          [35.7, 51.4],
          10
        )
        L.tileLayer(config.tile, {
          attribution: '@ Carpo',
          id: 'mapbox/streets-v11',
          tileSize: 512,
          zoomOffset: -1,
          accessToken: config.leaflet,
        }).addTo(map)
        this.map = map
      }

      if (this.polygonLayer) {
        this.map.removeLayer(this.polygonLayer)
        this.polygonLayer = null
      }

      this.polygonLayer = L.polygon(this.currentFenceCoords, {
        color: '#ff4949',
        fillColor: '#ff4949',
        fillOpacity: 0.5,
        interactive: false,
      }).addTo(this.map)

      const bounds = this.polygonLayer.getBounds()
      this.map.fitBounds(bounds)
    },
  },
}
</script>
